declare global {
  interface Window {
    KARMA_TESTS_RUNNING?: boolean;
  }
}

import * as angular from 'angular';
import { loadTranslationsFromWindowConfig } from './translations/load-translations';

function DOMContentLoaded() {
  return new Promise((resolve) => window.addEventListener('DOMContentLoaded', resolve, { once: true }));
}

export function bootstrapAppWhenReady(module: string, element: HTMLElement = document.documentElement) {
  Promise.all([DOMContentLoaded(), loadTranslationsFromWindowConfig()]).then(() => {
    if (!window.KARMA_TESTS_RUNNING) {
      angular.bootstrap(element, [module]);
    } else {
      element.setAttribute('ng-app', module);
    }
  });
}
